import $ from 'jquery';
import Swiper from 'swiper/bundle';

export function initBasics() {

    var menu = $('header');
    
    $('.toggle-menu').click(function(e){
        $('body').toggleClass('show-mobile-menu');
    });

    /* Mobile menu */
    $('header #mobile-menu li.menu-item-has-children').on('click', function(event){
        if ($(event.target).closest('a').length) {

        } else {
            $(this).toggleClass("open");
        }
    });


    $('div.dropdown a.nav-link').on('touchstart', function (e) {
        'use strict'; //satisfy code inspectors
        var link = $(this); //preselect the link
        if (link.hasClass('taphover')) {
            return true;
        } else {
            link.addClass('taphover');
            $('div.dropdown a').not(this).removeClass('taphover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    $('body').on('touchstart', function(e){
        var touch = $(this);
        $('.taphover').removeClass('taphover');
    });

    // Function On Scroll
    $(window).scroll(function() {
        checkMenu(200);
        checkTopbar();
    });
    checkMenu();
    checkTopbar();

    // Hide topbar on scroll
    var lastScrollTop = 0;
    function checkTopbar() {
        var scrollTop = $(window).scrollTop();
        var topbar = $('#topbar');
        var mainHeader = $('#main-header');
        
        if (scrollTop > 100) {
            // User is scrolling down - hide topbar
            topbar.addClass('-translate-y-full');
        } else {
            // User is at top - show topbar
            topbar.removeClass('-translate-y-full');
        }
        
        lastScrollTop = scrollTop;
    }

    // Make Menu Sticky
    function checkMenu(){
        var firstSection = $('section').first();
        var isHeroSection = firstSection.hasClass('hero-section');
        var headerMargin = $('.header-margin');
        
        // If first section is not a hero section, add color class immediately
        if (!isHeroSection) {
            $(menu).addClass('color');
            // Show header-margin div to create space
            headerMargin.addClass('active');
        } else {
            // Add BG when first section has class 'menu-color'
            if (firstSection.hasClass('menu-color')){
                $(menu).addClass('color');
            } else {
            // Add Color when Scrolled trough first section
                var top = (window.scrollY < (firstSection.height() - $('#masthead').height()) ? true : false );
            if(!top && !window.scrollY==0) {
                $(menu).addClass('color');
            } else {
                $(menu).removeClass('color');
                }
            }
            // Hide header-margin div when hero section is present
            headerMargin.removeClass('active');
        }
    }

    // Open Forms
    $('.open-form').click(function(e){
        e.preventDefault();
        var form = $(e.target).data('form');
        $('body').attr('data-form', form);
        $('sidebar#' + form).addClass('active');
    });

    // Close Forms
    $('.close-form, sidebar .overlay').click(function(){
        $('body').data('form', '');
        $('sidebar').removeClass('active');
    });
    $(document).on('keyup', function(e) {
        if (e.key == "Escape") {
            $('body').data('form', '');
            $('sidebar').removeClass('active');
        }
    });

    // Industry Swiper
    if($('.industries-swiper').length){
        var industriesSwipers = $('.industries-swiper');
        for(var i = 0; i < industriesSwipers.length; i++){
            var industriesSwiper = new Swiper(industriesSwipers[i], {
                spaceBetween: 12,
                slidesPerView: 1.5,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: {
                    slidesPerView: 1.8,
                    spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1600: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                },
                navigation: {
                    nextEl: ".swiper-btn-next",
                    prevEl: ".swiper-btn-prev",
                },
            });
        }
    }

    // Solutions Swiper
    if($('.solutions-swiper').length){
        var solutionsSwipers = $('.solutions-swiper');
        for(var i = 0; i < solutionsSwipers.length; i++){
            var solutionsSwiper = new Swiper(solutionsSwipers[i], {
                spaceBetween: 10,
                slidesPerView: 2,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: {
                    slidesPerView: 2.2,
                    spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    },
                    1600: {
                        slidesPerView: 5,
                        spaceBetween: 20
                    },
                }
            });
        }
    }

    // Highlights Swiper
    if($('.highlights-swiper').length){
        var highlightsSwipers = $('.highlights-swiper');
        for(var i = 0; i < highlightsSwipers.length; i++){
            var highlightsSwiper = new Swiper(highlightsSwipers[i], {
                spaceBetween: 10,
                slidesPerView: 1,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: {
                    slidesPerView: 1,
                    spaceBetween: 32
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    },
                },
                navigation: {
                    nextEl: ".swiper-btn-next",
                    prevEl: ".swiper-btn-prev",
                },
            });
        }
    }

    // Photo Swiper
    if($('.photos-swiper').length){
        const aanbodSwiper = new Swiper('.photos-swiper', {
            direction: 'horizontal',
            slidesPerView: 1.5,
            spaceBetween: 10,
            freeMode: false,
            speed: 5000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            loop: true,
            breakpoints: {
                640: {
                    slidesPerView: 1.5,
                    spaceBetween: 10
                },
                920: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1600: {
                    slidesPerView: 3,
                }
            },
            navigation: {
                nextEl: ".swiper-btn-next",
                prevEl: ".swiper-btn-prev",
            },
    
        });
    }

    if($('.client-swiper').length){
        var clientSwipers = document.getElementsByClassName('client-swiper');
        for(var i = 0; i < clientSwipers.length; i++){
            var clientSwiper = new Swiper(clientSwipers[i], {
                spaceBetween: 12,
                slidesPerView: 2,
                speed: 4000,
                loop: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                allowTouchMove: false,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 12,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 40
                    },
                    1600: {
                        slidesPerView: 4,
                        spaceBetween: 40
                    },
                }
            });
        }
    }
}